/* eslint-disable @typescript-eslint/no-use-before-define */
import { IGraph, ISubGraph, LNode } from "../types";
import Graph from "../Graph";

export function split(g: IGraph): ISubGraph[] {
	let core = g.getNodes();
	if (core.length < 3) return [{ g }];

	const first = core[0];
	const free = [];
	let count = core.length + 1;

	while (count != core.length) {
		count = core.length;
		core = core.filter(a => {
			if (a.links.length == 1) {
				const to = g.hash[a.links[0].id];
				if (to) to.links = to.links.filter(b => b.id != a.id);
				free.push(a);

				return false;
			}

			return true;
		});
	}

	//tree graph, no loops
	if (core.length < 2) {
		// restore links
		free.filter(a => a.links.length > 0).forEach(a => {
			a.links[0].links.push(a);
		});

		g.root(g.toTree(first));
		return [{ g }];
	}

	const freeHash = {};
	free.forEach(a => (freeHash[a.id] = a));

	//detect roots
	const roots = free.filter(a => !freeHash[a.links[0].id]).map(a => [a]);
	//restore bidirectional links
	free.forEach(a => {
		const to = freeHash[a.links[0].id];
		if (to) to.links.push(a);
	});

	const trees = roots.map(r => {
		let i = 0;
		let next;
		while ((next = r[i++])) {
			const lcount = next.links.length;
			if (lcount > 1)
				for (let i = 1; i < lcount; i++) {
					const to = next.links[i];
					r.push(to);
				}
		}

		const root = r[0].links.splice(0, 1)[0].id;
		return graphFromArray(r, root);
	});

	// core and trees
	return [graphFromArray(core, null)].concat(trees);
}

function graphFromArray(data: LNode[], root: string): ISubGraph {
	const g = new Graph();
	g.importNodes(data);

	return { g, root };
}
